export default {"src":"/_next/static/media/quote.7857382d.svg","height":21,"width":25,"blurWidth":0,"blurHeight":0};